<template>
  <StepTemplate class="StepContact" :error="error" stepName="stepContact" largeBtn @nextStep="$emit('nextStep', 1)">
    <v-container fluid class="StepContact-container">
      <v-row>
        <v-col class="Section-infos" cols="12" md="6">
          <div class="flex-grow-1">
            <h3 class="Infos-title">{{ $t('onBoarding.stepContact.sectionTitle') }}</h3>
            <p class="Infos-subtitle mt-2">{{ $t('onBoarding.stepContact.sectionSubtitle') }}</p>
          </div>
          <div class="Input-container">
            <TextFieldValidation
              v-model="contact.email"
              name="emailName"
              type="email"
              :label="$t('onBoarding.stepContact.emailLabel')"
              rules="required|email"
              data-e2e="StepContactUserEmail"
              disabled
            />
          </div>
          <div class="Input-container">
            <TextFieldValidation
              v-model="contact.location"
              name="locationName"
              type="text"
              :label="$t('onBoarding.stepContact.locationLabel')"
              rules="required"
              data-e2e="StepContactUserLocation"
              disabled
            />
          </div>
        </v-col>
        <v-col class="Section-img" cols="12" md="6">
          <img :src="require(`@/assets/onboarding-calendar-${$site}.png`)" alt="Calendar logo" />
        </v-col>
      </v-row>
    </v-container>
  </StepTemplate>
</template>

<script>
import TextFieldValidation from '@/components/lib/inputValidation/textFieldValidation'
import StepTemplate from '@/components/onboarding/UI/StepTemplate'
export default {
  name: 'StepContact',
  components: {
    StepTemplate,
    TextFieldValidation
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    error: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
.StepContact-container {
  .Section-infos {
    padding-left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .Infos-title {
    color: var(--v-secondary-base);
    font-weight: 900;
    font-size: 1.6rem;
  }
  .Infos-subtitle {
    color: var(--v-secondary-base);
    font-weight: 300;
    font-size: 1.2rem;
  }
  .Input-container {
    max-width: 500px;
    margin-top: 20px;
  }
  .Section-img {
    display: flex;
    justify-content: center;
    img {
      max-height: 100%;
      max-width: 100%;
      object-fit: contain;
      margin-right: 0;
    }
  }
}
</style>

<style lang="scss">
.StepContact {
  .v-input__slot {
    &::before {
      border-image: none !important;
    }
    input {
      color: #959595 !important;
      font-weight: bold;
    }
  }
}
</style>
